import axios from 'axios';

/**
 * Формат QR лояльности — один и тот же у динамического и статичного кода:
 *
 *   9009*9*1*5999366840041   — динамический, пришёл с бэкенда: version 1, токен
 *   9009*9*2*123456          — статичный, собран офлайн: version 2, id пользователя
 *
 * Сегменты через `*`. Третий — версия: по ней касса отличает живой код от
 * офлайн-копии и понимает, что проверять срок действия у той нечего.
 * Последний — кого искать: у динамического это одноразовый токен с бэкенда,
 * у статичного — id пользователя, потому что токен без сети взять негде.
 */
const QR_SEPARATOR = '*';
const STATIC_QR_VERSION = '2';
/** Постоянные сегменты перед версией — как их ждёт касса. */
const QR_PREFIX_SEGMENTS = ['9009', '9'];

export const buildStaticLoyaltyQr = (userId: string) =>
  [...QR_PREFIX_SEGMENTS, STATIC_QR_VERSION, userId].join(QR_SEPARATOR);

/**
 * Запрос не дошёл до сервера или ответ не вернулся: нет сети, таймаут, DNS.
 *
 * Принципиальная граница для выбора режима. Отсутствие сети — повод показать
 * статичный код; ответ сервера с ошибкой (500, 401) — нет: интернет есть,
 * просто бэкенд нездоров, и подменять его локальным кодом спека запрещает.
 */
export const isNetworkError = (error: unknown) =>
  axios.isAxiosError(error) && !error.response;
